import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'d-flex bra-8': !_vm.VISAO_VERTICAL_ATIVA},attrs:{"id":"bloco-detalhes"}},[(_vm.PRODUTO_SELECIONADO.idproduto)?_c('DetalhesProduto'):[_c('MovimentacoesEstoque',{class:_vm.CLASSES_CSS_MOVIMENTACOES_ESTOQUE,attrs:{"update_resize":Number(_vm.VISAO_VERTICAL_ATIVA),"filtros":_vm.FILTROS_STORE}}),_c(VDivider,{attrs:{"vertical":!_vm.VISAO_VERTICAL_ATIVA}}),_c('RupturaEstoque',{class:_vm.CLASSES_CSS_RUPTURA_ESTOQUE})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }